import { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminMagicVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const hasVerified = useRef(false);

  useEffect(() => {
    const verifyToken = async () => {
      // Prevent double verification in React Strict Mode
      if (hasVerified.current) return;
      hasVerified.current = true;

      const token = searchParams.get('token');
      
      if (!token) {
        toast.error('Invalid magic link');
        navigate('/admin/login');
        return;
      }

      try {
        const response = await axios.post(`${API}/admin/auth/magic-verify?token=${token}`);
        localStorage.setItem('admin_token', response.data.access_token);
        toast.success('Admin login successful!');
        setVerifying(false);
        // Small delay to ensure toast is visible
        setTimeout(() => {
          navigate('/admin');
        }, 500);
      } catch (error) {
        setVerifying(false);
        const errorMsg = error.response?.data?.detail || 'Invalid or expired link';
        toast.error(errorMsg);
        setTimeout(() => {
          navigate('/admin/login');
        }, 1500);
      }
    };

    verifyToken();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50 flex items-center justify-center">
      <div className="text-center">
        {verifying ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-slate-600">Verifying admin access...</p>
          </>
        ) : (
          <div className="text-slate-600">Redirecting...</div>
        )}
      </div>
    </div>
  );
};

export default AdminMagicVerify;
